import type { TFunction } from 'i18next'
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import type { InvoiceMailTask } from '@/modules/Invoice/types'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Eye } from 'lucide-react'
import { formatDate } from '@/utils/function'

const getStatusVariant = (
    status: string
): 'default' | 'secondary' | 'destructive' | 'outline' => {
    switch (status) {
        case 'completed':
            return 'default'
        case 'failed':
            return 'destructive'
        case 'pending':
            return 'secondary'
        case 'processing':
            return 'outline'
        default:
            return 'outline'
    }
}

export const getMailHistoryColumns = (
    t: TFunction,
    onViewMetadata: (row: InvoiceMailTask) => void
): DataTableColumn<InvoiceMailTask>[] => [
    {
        key: 'task_id',
        title: t('task-id'),
        width: 100,
    },
    {
        key: 'task_name' as any,
        title: t('subject'),
        width: 500,
        render: (_, row) => (
            <span className="truncate block" title={row.metadata?.subject}>
                {row.metadata?.subject || '-'}
            </span>
        ),
    },
    {
        key: 'task_status',
        title: t('status'),
        width: 150,
        render: (value) => {
            const textMap: Record<string, string> = {
                completed: t('sent'),
                failed: t('failed'),
                pending: t('pending'),
                processing: t('processing'),
            }
            return (
                <Badge variant={getStatusVariant(value)}>
                    {textMap[value] || value}
                </Badge>
            )
        },
    },
    {
        key: 'task_created_at',
        title: t('created-time'),
        width: 180,
        render: (value) => (
            <span className="text-muted-foreground">
                {formatDate(value) || '-'}
            </span>
        ),
    },
    {
        key: 'task_completed_at',
        title: t('completed-time'),
        width: 180,
        render: (value) => (
            <span className="text-muted-foreground">
                {value ? formatDate(value) : '-'}
            </span>
        ),
    },
    {
        key: 'task_bind',
        title: t('task-type'),
        width: 300,
    },
    {
        key: 'metadata' as any,
        title: 'Metadata',
        width: 100,
        render: (_, row) => (
            <Button
                variant="ghost"
                size="icon"
                onClick={() => onViewMetadata(row)}
            >
                <Eye className="w-4 h-4" />
            </Button>
        ),
    },
]
